<div *ngIf="value">Yes</div>
<div *ngIf="value === false">No</div>
